/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import React from "react";
/* eslint-disable no-restricted-imports -- firebase compat: 新たにコードを追加する時は modular API を使う。modular API へ移行したらこのコメントごと削除する */
import "firebase/compat/auth";
import "firebase/compat/database";
import "firebase/compat/firestore";
import "firebase/compat/storage";
/* eslint-enable no-restricted-imports */
import { ContentsLayout } from "../../styles";
import { Link } from "react-router-dom";
import { BreadcrumbNavigation } from "ui/BreadcrumbNavigation";

export const ProvisionOfPersonalInfo: React.FC = () => {
  return (
    <div
      css={css`
        min-height: calc(100vh - 245px);
        background-color: #fff;
      `}
    >
      <BreadcrumbNavigation
        breadcrumbs={[
          // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
          { label: "ホーム", link: "/" },
          // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
          { label: "アカウント", link: "/account" },
          // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
          { label: "個人情報の第三者提供について", link: null },
        ]}
      />

      <ContentsLayout>
        <div
          css={css`
            max-width: 640px;
            margin: 0 auto;
          `}
        >
          <h2
            css={css`
              margin-bottom: 16px;
              font-size: 20px;
              font-weight: bold;
            `}
            // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
          >
            個人情報の第三者提供について
          </h2>

          <p
            css={css`
              font-size: 14px;
              line-height: 1.5em;
              a {
                color: #00c2ae;
                text-decoration: underline;
              }
            `}
          >
            {/* eslint-disable-next-line no-restricted-syntax -- i18n 未対応 */}
            <Link to={"/privacy-policy"}>プライバシーポリシー</Link>
            に個人情報の第三者提供の詳細内容が記載されています。
            {/* eslint-disable-next-line no-restricted-syntax -- i18n 未対応 */}
            <br />
            個人情報の第三者提供を停止したい場合は
            <a
              href="https://forms.gle/Tzuh931E8Gh1vV2k8"
              target="_blank"
              rel="noopener noreferrer"
              // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
            >
              停止依頼フォーム
              {/* eslint-disable-next-line no-restricted-syntax -- i18n 未対応 */}
            </a>
            からご依頼ください。
          </p>
        </div>
      </ContentsLayout>
    </div>
  );
};
